import Base from "./Base";

class BOMProject extends Base {
    toObjectWithBOMProjectID(direct_res = false) {
        let bomProjectList = {};
        let res = {};
        if (direct_res.data !== undefined &&
            Array.isArray(direct_res.data) &&
            direct_res.data.length > 0
        ) {
            direct_res.data.map((v) => {
                bomProjectList[v.projectId] = v;
            });
        }
        res.bomProjectList = bomProjectList;
        return res;
    }
}

export default BOMProject;